export interface PopupDataModel {
  heroText: string;
  buttonLabel: string;
  learnMoreLink: string;
  imageLink: string;
}

export const popupListData: PopupDataModel[] = [
  {
    heroText: 'The new Controller Experience is live',
    buttonLabel: 'Check it out',
    learnMoreLink: 'https://support.bymason.com/hc/en-us/articles/16570354960411',
    imageLink: 'https://mcdn.bymason.com/runway/controller/new-controller-banners/Sunset+Promo+Image.png',
  },
  // {
  //   heroText: 'X-Ray makes troubleshooting Mason devices easy',
  //   buttonLabel: 'Check it out',
  //   learnMoreLink:
  //     'https://support.bymason.com/article/160-x-ray-now-available-in-the-new-controller-experience',
  //   imageLink:
  //     'https://mcdn.bymason.com/runway/controller/new-controller-banners/XRay+Sunset+Promo+Image.png',
  // },
  {
    heroText: 'Users can now edit YAML files in Controller',
    buttonLabel: 'Check it out',
    learnMoreLink: 'https://support.bymason.com/hc/en-us/articles/16570222260891',
    imageLink:
      'https://mcdn.bymason.com/runway/controller/new-controller-banners/YAML+Sunset+Promo+Image.png',
  },
  {
    heroText: 'Updated Connectivity page is now available!',
    buttonLabel: 'Check it out',
    learnMoreLink: 'https://support.bymason.com/hc/en-us/articles/16746905839515',
    imageLink: 'https://mason-strapi.s3.us-west-2.amazonaws.com/Connectivity_Feature_Card_28a3407a74.png',
  },
];
